var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1489 11.3333C13.0789 12.6586 13.5236 13.3646 13.2589 13.9333C13.2322 13.9901 13.2011 14.045 13.1656 14.0979C12.7822 14.6666 11.7922 14.6666 9.81222 14.6666H6.18956C4.20956 14.6666 3.22022 14.6666 2.83689 14.0979C2.80192 14.0453 2.77073 13.9903 2.74356 13.9333C2.47889 13.3653 2.92356 12.6586 3.85356 11.3333M9.66756 5.99992C9.66756 6.44195 9.49196 6.86587 9.1794 7.17843C8.86684 7.49099 8.44292 7.66659 8.00089 7.66659C7.55886 7.66659 7.13494 7.49099 6.82238 7.17843C6.50982 6.86587 6.33422 6.44195 6.33422 5.99992C6.33422 5.55789 6.50982 5.13397 6.82238 4.82141C7.13494 4.50885 7.55886 4.33325 8.00089 4.33325C8.44292 4.33325 8.86684 4.50885 9.1794 4.82141C9.49196 5.13397 9.66756 5.55789 9.66756 5.99992Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83897 11.6626C8.61379 11.8792 8.31345 12.0003 8.00097 12.0003C7.68849 12.0003 7.38815 11.8792 7.16297 11.6626C5.10364 9.66725 2.3443 7.43859 3.68964 4.20259C4.4183 2.45259 6.16497 1.33325 8.00097 1.33325C9.83697 1.33325 11.5843 2.45325 12.3123 4.20259C13.6563 7.43392 10.9036 9.67392 8.83897 11.6626Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location_1.5960bf2f146d8a98d31920355362fc8f.svg";
export { ForwardRef as ReactComponent };